import logo from './logo.svg';
import './App.css';
import './Reservation.css';
import React, { useRef, useState, useEffect } from 'react';

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Header from "./components/Header";

import Footer from "./components/Footer.js";

import TermsAndConditions from "./components/TermsAndConditions.js";
import { useTranslation } from './hooks/useTranslation';
import ReservationCalendar from './components/ReservationCalendar';


function MainLayout() {
  const { t, lang, setLang } = useTranslation('es');
  return (
    <>
    
      <Routes>
        <Route path="/" element={<Header t={t} lang={lang} setLang={setLang} />} />
      
      </Routes>
      <Footer translate={t}/>
    </>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/terms" element={<TermsAndConditions />} />
       
     
        <Route path="/*" element={<MainLayout />} />
      </Routes>
    </Router>
  );
}


export default App;
